<template>
  <!-- 账号相关页面（任務中心 / 個人中心）不再跳页，
       就地以弹窗打开 —— 跳页会丢掉当前工作台的状态（正在生成的图、已勾选的竞品图）。
       每个弹窗都带 destroy-on-close：关闭即销毁，下次打开重新 created() 拉最新数据。
       注：「範本管理」已移到管理端，客户端不再有入口。 -->
  <div class="acct-dlgs">
    <el-dialog
      title="任務中心"
      :visible.sync="jobs"
      width="1160px"
      top="6vh"
      append-to-body
      destroy-on-close
      custom-class="acct-dlg"
    >
      <job-center />
    </el-dialog>

    <el-dialog
      title="個人中心"
      :visible.sync="profile"
      width="900px"
      top="8vh"
      append-to-body
      destroy-on-close
      custom-class="acct-dlg"
    >
      <profile-panel />
    </el-dialog>
  </div>
</template>

<script>
import JobCenter from '../views/JobCenter.vue'
import ProfilePanel from '../views/Profile.vue'

export default {
  name: 'AccountDialogs',
  components: {
    JobCenter,
    ProfilePanel
  },
  data() {
    return {
      jobs: false,
      profile: false
    }
  },
  methods: {
    /** 打开其中一个（其余先关掉，避免叠两个弹窗） */
    open(which) {
      this.closeAll()
      if (typeof this[which] === 'boolean') {
        this[which] = true
      }
    },
    closeAll() {
      this.jobs = false
      this.profile = false
    }
  }
}
</script>

<style>
/* 屏幕比弹窗窄时不让它溢出视口（任務中心列多，宽 1160px） */
.acct-dlg {
  max-width: 94vw;
}
/* 弹窗内的 el-card 去掉投影和边框：卡片嵌套在弹窗里会显得一层套一层 */
.acct-dlg .el-dialog__body .el-card {
  box-shadow: none;
  border: 1px solid var(--c-border);
}
.acct-dlg .el-dialog__body {
  padding-top: 8px;
}
</style>
